// ETA grossier en ville (~18 km/h : moto + arrêts + feux), depuis une distance.
//
// Extrait de `matchingService`, où il servait déjà à annoncer le délai d'un
// candidat. Le suivi de course a besoin du MÊME calcul : deux formules
// différentes afficheraient deux délais contradictoires pour une même Main,
// l'un pendant la recherche, l'autre pendant la course.
export function etaMinutesFromKm(km: number): number {
  return Math.max(1, Math.round((km / 18) * 60));
}
